import { SchoolSportSeason } from '@maxpreps/apiserviceclients/apiModels';
import { publicOrigin } from '@maxpreps/network/src/origins';
import { getReturnUrl } from '@maxpreps/shared/functions/primitiveHelpers/urlHelpers';
import { getWebFormsTeamAdminUrl } from '@maxpreps/shared/functions/utils/getWebFormsAdminUrl';
import { Page } from './../utils/pages';

export const getAdminEnterScoresLink = (
  teamId: string,
  allSeasonId: string,
  sportSeasonId: string,
  contestId: string
) =>
  getWebFormsTeamAdminUrl(
    `/admin/coach/stats/enterscore.aspx?id=${contestId}`,
    teamId,
    allSeasonId,
    sportSeasonId
  );

export const getAdminHudlStatsLink = (
  teamId: string,
  allSeasonId: string,
  sportSeasonId: string,
  contestId: string
) =>
  getWebFormsTeamAdminUrl(
    `/admin/coach/stats/hudl.aspx?groupid=0&id=${contestId}`,
    teamId,
    allSeasonId,
    sportSeasonId
  );

export const getAdminEnterStatsLink = (
  teamId: string,
  allSeasonId: string,
  sportSeasonId: string,
  contestId: string
) =>
  getWebFormsTeamAdminUrl(
    `/admin/coach/stats/enterstat.aspx?id=${contestId}`,
    teamId,
    allSeasonId,
    sportSeasonId
  );

// MP-10754
export const getPublicReportScoreUrl = (
  contestId: string,
  sportSeasonId: string
) =>
  `${publicOrigin}/utility/reportscore/report_final_score.aspx?contestid=${contestId}&ssid=${sportSeasonId}&returnurl=${getReturnUrl()}`;

export const getTeamUrl = (
  page: Page,
  teamCanonicalUrl: string,
  queryParams: Record<string, any> = {}
) => {
  // if page is null it's a programmer error
  if (page == null) {
    throw new Error(`'Page' cannot be null: ${page}.`);
  }

  // if teamCanonicalUrl is null it's likely a data error
  // dont' blow up - try to fail gracefully
  if (!teamCanonicalUrl) {
    return '';
  }

  // helper logic to auto-append admin=1
  if (
    page.indexOf('/admin') > -1 ||
    page.indexOf('/edit') > -1 ||
    page.indexOf('/bulk-edit') > -1 // roster bulk + schedule bulk (when done)
  ) {
    queryParams.admin = 1;
  }

  const url: string[] = [];

  let base = teamCanonicalUrl ?? '';
  if (page) base = base.replace('/schedule/', `/`);

  url.push(
    base
    // .replace('dev.maxpreps.com', 'z.maxpreps.com:3000'); // uncomment to test locally
  );
  // may be '' but that is okay...
  url.push(page);

  // add query params
  if (Object.keys(queryParams).length > 0) {
    url.push(page.indexOf('?') > -1 ? '&' : '?');

    url.push(new URLSearchParams(queryParams).toString());
  }

  // return
  return url.join('');
};

export const getProgramCanonicalUrl = (
  teamSeasonPickerData: SchoolSportSeason[],
  level: string // this could map to TeamLevel?
) =>
  teamSeasonPickerData.find(x => x.level == level && x.isPublished)
    ?.canonicalUrl;
